import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const BellFilled = createSvg({
  name: 'bell-filled',
  path: /*#__PURE__*/createElement("g", {
    id: "bell-filled"
  }, /*#__PURE__*/createElement("path", {
    d: "M40.3 69.5c-2.6-.7-4.4-3.1-4.4-5.8H15.6c-1.3 0-2.4-1.1-2.4-2.4v-4c0-1 .6-1.9 1.6-2.3 5.5-2 9.3-7.1 9.6-13 .3-4.7.5-9.5.8-14.2.2-4.2 3.7-7.5 7.9-7.5h2.4v-3.5c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5v3.5h2.4c4.2 0 7.7 3.3 7.9 7.5.3 4.7.5 9.5.8 14.2.3 5.8 4.1 10.9 9.6 13 1 .4 1.6 1.3 1.6 2.3v4c0 1.3-1.1 2.4-2.4 2.4H47.9c0 2.7-1.8 5-4.4 5.8v2.6c0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6v-2.6"
  }))
});

export default BellFilled;
